export default "__VITE_ASSET__dJo_gId5__"